import React from 'react';

export const Spinner: React.FC<{ size?: number }> = ({ size = 24 }) => {
  return (
    <>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
      <div
        style={{
          width: size,
          height: size,
          border: '3px solid var(--neutral-300)',
          borderTop: '3px solid var(--blue-600)',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}
      />
    </>
  );
};